import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./components/App";
import GlobalStyles from "./styles/GlobalStyles";
import { ScrollProvider } from "./hooks/use-scroll";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollProvider>
        <GlobalStyles />
        <App />
      </ScrollProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
